import { render, staticRenderFns } from "./register-2.vue?vue&type=template&id=620c7a4a&scoped=true&"
import script from "./register-2.vue?vue&type=script&lang=js&"
export * from "./register-2.vue?vue&type=script&lang=js&"
import style0 from "./register-2.vue?vue&type=style&index=0&id=620c7a4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c7a4a",
  null
  
)

export default component.exports